import {
	CLEAR_SHOPIMAGESSAVE,
	SHOP_IMAGE_SAVED,
	SHOP_IMAGE_SAVING,
	SHOP_IMAGE_SAVING_FAILED,
} from "../actions/types";

const initialState = {
	isSaving: false,
	isSaved: false,
	isFailed: false,
	data: {},
};
export default function (state = initialState, action) {
	switch (action.type) {
		case SHOP_IMAGE_SAVING:
			return {
				...state,
				isSaving: true,
				isSaved: false,
				isFailed: false,
			};
		case SHOP_IMAGE_SAVED:
			return {
				...state,
				isSaving: false,
				isSaved: true,
				isFailed: false,
				data: action.payload,
			};
		case SHOP_IMAGE_SAVING_FAILED:
			return {
				...state,
				isSaving: false,
				isSaved: false,
				isFailed: true,
			};
		case CLEAR_SHOPIMAGESSAVE:
			return {
				...state,
				isSaving: false,
				isSaved: false,
				isFailed: false,
				data: {},
			};

		default:
			return state;
	}
}
